/**
 * Created by forbiz on 2019-02-11.
 */

const orderCart = () => {
    const $document = $(document);

    const orderCartAccd = () => {
        $document
            .on('click', '.btn__moreView', function(e) {
                var $this = $(this);
                
                if ( !$this.hasClass('on') ) {
                    $this.addClass('on').text('접어두기');
                    $this.closest('.orderCartBox__list__inner').siblings('.boxInner').stop().slideDown();
                } else {
                    $this.removeClass('on').text('펼쳐보기');
                    $this.closest('.orderCartBox__list__inner').siblings('.boxInner').stop().slideUp();
                }
                
                e.preventDefault();
            });
    };

    const orderCartInit = () => {
        orderCartAccd();
    };

    orderCartInit();
};

export default orderCart;